import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { _SalesOrderItemQuota, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { SelectProductEditor } from "../../../../Factoty&Production/ManufacturingStandars/Components/SelectProductEditor";
import { AccountEditor } from "../../../../editor/AccountEditor";
import { CurrencyEditor } from "../../../../erp/cellEditor/Currency/CurrencyEditor";
import { MeasurementUnitCodeEditor } from "../../../../erp/MeasurementUnitCode/MeasurementUnitCode.editor";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { BasicTable, MASK_DATE_YYYYMMDD_HHMM, MASK_DECIMAL, MASK_MONEY, MASK_NUMBER } from "../../../../theme/Component/BasicTable";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import useModal, { MODAL_LG, MODAL_md } from "../../../../theme/Component/hooks/useModal";
import usePaginator from "../../../../theme/Component/usePaginator";
import { EditorSalesOrderItem } from "../SalesOrderItem/EditorSalesOrderItem";
import { SalesOrderItemAccountEditor } from "./SalesOrderItemAccountEditor";

interface Props {
    idSalesOrder: number;
    salesOrderDate: any;
}

interface FilterProps {
    IDAccount?: number;
    AccountName?: string;
    AccountNit?: string;
    RegexStr?: string;
}

const RECORDS_PER_PAGE = 15;

export const SalesOrderItemQuota = ({ idSalesOrder, salesOrderDate }: Props) => {
    const {
        instance,
        lista,
        setLista,
        bean,
        setBean,
        addRequiredFields,
        validateForm,
        isRequired,
        isMissing,
    } = useDataBean(_SalesOrderItemQuota);
    const paginator = usePaginator();
    const [filter, setFilter] = useState<FilterProps>({ RegexStr: "" });
    const [submitted, setSubmitted] = useState(false);

    const modalCreate = useModal("Agregar cotización de proveedor", MODAL_LG);
    const modalDelete = useModal("Eliminar cotización de proveedor", MODAL_md);

    useEffect(() => {
        addRequiredFields([
            "IDSalesOrderItem",
            "IDAccount",
            "IDProduct",
            "IDMeasurementUnitCode",
            "IDCurrency",
            "TotalItemAmount",
        ]);
    }, []);

    useEffect(() => {
        if (filter.IDAccount != null) {
            getLista();
        } else {
            setLista([]);
        }
    }, [idSalesOrder, salesOrderDate, paginator.page]);

    const getLista = () => {
        if (idSalesOrder == null || salesOrderDate == null) {
            setLista([]);
            return;
        }

        instance.getSalesOrderItemQuotaCatalog(
            idSalesOrder,
            salesOrderDate,
            null,
            filter.IDAccount,
            filter.RegexStr,
            paginator.page,
            RECORDS_PER_PAGE
        ).then((resp: any) => {
            const result = resp?.List ?? [];
            result.forEach((item: any) => {
                const data = item.DataBeanProperties;
                data.Account = `${data.AccountNit ?? ""} - ${data.AccountName ?? ""}`;
            });

            paginator.setPages(resp?.NumberOfPages ?? 0);
            paginator.setRecords((resp?.NumberOfPages ?? 0) * RECORDS_PER_PAGE);
            paginator.setRegiPerPage(RECORDS_PER_PAGE);
            setLista(result);
        }).catch((err: any) => toast.error(err));
    };

    const search = () => {
        if (filter.IDAccount == null) {
            toast.error("El proveedor es obligatorio");
            setLista([]);
            return;
        }

        if (paginator.page !== 1) {
            paginator.setPage(1);
        } else {
            getLista();
        }
    };

    const openCreate = () => {
        setSubmitted(false);
        setBean({
            IDSalesOrderItemQuota: null,
            IDSalesOrderItem: null,
            SalesOrderItemDescription: "",
            IDAccount: filter.IDAccount,
            AccountName: filter.AccountName,
            AccountNit: filter.AccountNit,
            IDProduct: null,
            ProductDescription: "",
            IDMeasurementUnitCode: null,
            IDCurrency: null,
            TotalItemAmount: null,
        });
        modalCreate.open();
    };

    const createItem = () => {
        setSubmitted(true);
        const hasInvalidSelectors = !bean.IDAccount || !bean.IDProduct || !bean.IDMeasurementUnitCode || !bean.IDCurrency;

        if (!validateForm() || hasInvalidSelectors) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        }

        instance.addSalesOrderItemQuota(
            bean.IDSalesOrderItem,
            salesOrderDate,
            bean.IDAccount,
            bean.IDProduct,
            bean.IDMeasurementUnitCode,
            bean.IDCurrency,
            bean.TotalItemAmount,
            _single.getAccountID()
        ).then(() => {
            toast.success("Cotización agregada correctamente");
            modalCreate.close();
            getLista();
        }).catch((err: any) => toast.error(err));
    };

    const deleteItem = () => {
        instance.deleteSalesOrderItemQuota(bean.IDSalesOrderItemQuota).then(() => {
            toast.success("Cotización eliminada correctamente");
            modalDelete.close();
            getLista();
        }).catch((err: any) => toast.error(err));
    };

    const head = [
        { title: "ID", property: "IDSalesOrderItemQuota", visible: true, mask: MASK_NUMBER },
        { title: "Descripción", property: "SalesOrderProductDescription", visible: true },
        { title: "Cantidad Requerida", property: "SalesOrderQuantity", visible: true, mask: MASK_DECIMAL },
        { title: "Unidad Medida Requerida", property: "SalesOrderMeasurementUnitCodeName", visible: true },
        { title: "Presupuesto", property: "SalesOrderTotalItemAmount", visible: true, mask: MASK_MONEY },
        { title: "Moneda Presupuesto", property: "SalesOrderCurrencyName", visible: true },
        { title: "Proveedor", property: "Account", visible: true },
        { title: "Producto Cotizado", property: "ProductDescription", visible: true },
        { title: "Unidad Medida Cotización", property: "MeasurementUnitCodeName", visible: true },
        { title: "Cantidad Cotizada", property: "Quantity", visible: true, mask: MASK_DECIMAL },
        { title: "Valor Unitario", property: "UnitaryValue", visible: true, mask: MASK_MONEY },
        { title: "Vr Total", property: "TotalItemAmount", visible: true, mask: MASK_MONEY },
        { title: "Moneda Cotización", property: "CurrencyName", visible: true },
        { title: "Empleado", property: "EmployeeName", visible: true },
        { title: "Fecha Creación", property: "Since", visible: true, mask: MASK_DATE_YYYYMMDD_HHMM },
    ];

    const rowButtons = (
        <ListMenu listaBotones={[
            {
                titulo: "Eliminar",
                icono: "ri-delete-bin-line",
                visible: _single.canDelete() && bean.IDSalesOrderItemQuota != null,
                evento: () => modalDelete.open(),
            },
        ]} />
    );

    const iconButtonsItem = [
        {
            nombre: "Agregar cotización",
            icono: "ri-file-add-line",
            visible: _single.canCreate(),
            evento: openCreate,
        },
    ];

    return (
        <div className="row">
            <div className="col-md-6">
                <SalesOrderItemAccountEditor
                    idSalesOrder={idSalesOrder}
                    salesOrderDate={salesOrderDate}
                    idSelector={filter.IDAccount}
                    label="Proveedor *"
                    onChange={(account: any) => {
                        setLista([]);
                        setFilter({
                            ...filter,
                            IDAccount: account?.IDAccount,
                            AccountName: account?.AccountName,
                            AccountNit: account?.AccountNit,
                        });
                    }}
                />
            </div>
            <div className="col-md-6">
                <label>Búsqueda por Texto</label>
                <input
                    className="form-control"
                    value={filter.RegexStr ?? ""}
                    onChange={(e) => setFilter({ ...filter, RegexStr: e.target.value })}
                    onKeyDown={(e) => e.key === "Enter" && search()}
                />
            </div>
            <div className="col-md-12 mt-4 p-2">
                <BasicButton icon="ri-search-line" eventClick={search}>Buscar</BasicButton>
            </div>
            <div className="col-md-12">
                <BasicTable
                    body={lista}
                    head={head}
                    rowSet={setBean}
                    listButtons={rowButtons}
                    iconButtons={iconButtonsItem}
                    records={paginator}
                />
            </div>

            <Modal modal={modalCreate.modal} updateModal={modalCreate.setModal} eventModal={createItem}>
                <div className="row">
                    <div className="col-md-12">
                        <label className={submitted && isMissing("IDSalesOrderItem") ? "has-error" : ""}>
                            Producto de la Oportunidad {isRequired("IDSalesOrderItem") ? <span className="text-danger">*</span> : ""}
                        </label>
                        <EditorSalesOrderItem
                            label=" "
                            idSalesOrder={idSalesOrder}
                            salesOrderDate={salesOrderDate}
                            idSelector={bean.IDSalesOrderItem}
                            render={bean.SalesOrderItemDescription}
                            onChange={(item: any) => setBean({
                                ...bean,
                                IDSalesOrderItem: item.IDSalesOrderItem,
                                SalesOrderItemDescription: `${item.IDSalesOrderItem} - ${item.Description ?? ""}`,
                            })}
                        />
                    </div>
                    <div className={`col-md-12 ${submitted && (isMissing("IDAccount") || !bean.IDAccount) ? "has-error" : ""}`}>
                        <AccountEditor
                            idAccount={bean.IDAccount ?? null}
                            label="Proveedor *"
                            onChange={(account: any) => setBean({
                                ...bean,
                                IDAccount: account?.IDAccount,
                                AccountName: account?.EntityName,
                                AccountNit: account?.Nit,
                            })}
                        />
                    </div>
                    <div className="col-md-12">
                        <label className={submitted && isMissing("IDProduct") ? "has-error" : ""}>
                            Producto Cotizado {isRequired("IDProduct") ? <span className="text-danger">*</span> : ""}
                        </label>
                        <SelectProductEditor
                            label=" "
                            value={bean.IDProduct}
                            renderValue={bean.ProductDescription}
                            onChange={(product: any) => setBean({
                                ...bean,
                                IDProduct: product.IDProduct,
                                ProductDescription: product.Description,
                                UnitaryValue: product.SalesValue,
                            })}
                        />
                    </div>
                    <div className="col-md-6">
                        <label className={submitted && (isMissing("IDMeasurementUnitCode") || !bean.IDMeasurementUnitCode) ? "has-error" : ""}>
                            Unidad de Medida {isRequired("IDMeasurementUnitCode") ? <span className="text-danger">*</span> : ""}
                        </label>
                        <MeasurementUnitCodeEditor
                            label=" "
                            idSelector={bean.IDMeasurementUnitCode}
                            onChange={(value: any) => setBean({ ...bean, IDMeasurementUnitCode: Number(value) })}
                        />
                    </div>
                    <div className={`col-md-6 ${submitted && (isMissing("IDCurrency") || !bean.IDCurrency) ? "has-error" : ""}`}>
                        <CurrencyEditor
                            id={bean.IDCurrency}
                            onchange={(value: number) => setBean({ ...bean, IDCurrency: value })}
                        />
                    </div>
                    <div className="col-md-6">
                        <label>Valor Unitario</label>
                        <input className="form-control" type="number" value={bean.UnitaryValue ?? ""} readOnly />
                    </div>
                    <div className="col-md-6">
                        <label className={submitted && isMissing("TotalItemAmount") ? "has-error" : ""}>
                            Valor Total Cotizado {isRequired("TotalItemAmount") ? <span className="text-danger">*</span> : ""}
                        </label>
                        <input
                            className="form-control"
                            type="number"
                            value={bean.TotalItemAmount ?? ""}
                            onChange={(e) => setBean({
                                ...bean,
                                TotalItemAmount: e.target.value === "" ? null : Number(e.target.value),
                            })}
                        />
                    </div>
                </div>
            </Modal>

            <ModalConfirm modal={modalDelete.modal} updateModal={modalDelete.setModal} eventModal={deleteItem}>
                <strong>Eliminar cotización {bean.IDSalesOrderItemQuota}</strong>
            </ModalConfirm>
        </div>
    );
};
